import React from 'react';
import { Link, Navigate } from "react-router-dom";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";
class Crearinfraccion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            articulo: "",
            inciso: "",
            descripcion: "",
            monto: "",
            redireccionar: false
        }
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    enviarDatos = (e) => {
        e.preventDefault();

        const { articulo, inciso, descripcion, monto } = this.state;

        const datosEnviar = { articulo, inciso, descripcion, monto };

       fetch(api + "infracciones", {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(datosEnviar)
})
            
        
        .then(respuesta => respuesta.json())
        .then((datosRespuesta) => {
            

            
            this.setState({
                mensaje: "Infracción creada con éxito"
            });

            
            setTimeout(() => {
                this.setState({
                    redireccionar: true
                });
            }, 2000);
        })
       
    }

    render() {
        const { articulo, inciso, descripcion, monto, mensaje, redireccionar } = this.state;

       
        if (redireccionar) {
            return <Navigate to="/infracciones" />;
        }

        return (
            <div className="card">
                <div className="card-header">
                    Infracciones
                </div>

                <div className="card-body">

                    
                    {mensaje && (
                        <div className="alert alert-success">
                            {mensaje}
                        </div>
                    )}

                    <form onSubmit={this.enviarDatos}>
                        <div className="form-group">
                            <label>Articulo</label>
                            <input
                                type="text"
                                name="articulo"
                                onChange={this.cambioValor}
                                value={articulo}
                                className="form-control"
                            />
                            <small className="text-muted">
                                Escribe el número de artículo
                            </small>
                        </div>

                        <div className="form-group">
                            <label>Inciso</label>
                            <input
                                type="text"
                                name="inciso"
                                onChange={this.cambioValor}
                                value={inciso}
                                className="form-control"
                            />
                            <small className="text-muted">
                                Escribe el inciso
                            </small>
                        </div>

                        <div className="form-group">
                            <label>descripcion</label>
                            <textarea
                                type="text"
                                name="descripcion"
                                onChange={this.cambioValor}
                                value={descripcion}
                                className="form-control"
                            ></textarea>
                            <small className="text-muted">
                                Escribe la descripción de la infracción
                            </small>
                        </div>

                         <div className="form-group">
    <label>Monto Q</label>

    <input
        type="number"
        step="0.01"
        name="monto"
        onChange={this.cambioValor}
        value={monto}
        className="form-control"
    />

    <small className="text-muted">
        Escribe el monto de la infracción
    </small>
</div>


                        <div className="btn-group">
                            <button type="submit" className="btn btn-success">
                                Agregar Nueva infracción
                            </button>

                            <Link to="/infracciones" className="btn btn-primary">
                                Cancelar
                            </Link>
                        </div>
                    </form>

                </div>

                <div className="card-footer text-muted">
                    PMT EN TODO
                </div>
            </div>
        );
    }
}

export default Crearinfraccion;